// extracted by mini-css-extract-plugin
module.exports = {"wallet_row":"WalletHeader_wallet_row__1zQZY","value":"WalletHeader_value__12_M5","amount":"WalletHeader_amount__rkV15","token":"WalletHeader_token__2kiZL"};